import { CalendarModule } from 'primeng/calendar';
import { ToastrModule } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesktopContactUsComponent } from './desktop-contact-us.component';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';



@NgModule({
  declarations: [
    DesktopContactUsComponent,
  ],
  imports: [
    CommonModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextareaModule,
    InputTextModule,
    FileUploadModule,
    ToastrModule,
    AutoCompleteModule,
    CalendarModule
  ],
  providers: [],
  exports: [
    DesktopContactUsComponent
  ]
})
export class DesktopContactUsModule { }
